import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useUniqueId } from "../../hooks/useUniqueId";
import { LinearProgress } from "../linear-progress/LinearProgress";
import * as Styled from "./ProgressBar.styled";
export const ProgressBar = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { labelId, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy = labelId, color, height, id, variant, palette = "expressiveInformative", stringMap = {}, value, ...otherProps } = props;
    const { leftMessage, rightMessage } = stringMap;
    const messageId = useUniqueId("progress-bar-message-");
    const progressBarId = useUniqueId("progress-bar-");
    const hasMessage = !!(leftMessage || rightMessage);
    return (_jsxs(Styled.Wrapper, { ref: ref, "data-testid": "ProgressBar", ...otherProps, children: [hasMessage && (_jsxs(Styled.MessageWrapper, { id: messageId, children: [leftMessage && _jsx(Styled.Message, { children: leftMessage }), rightMessage && _jsx(Styled.Message, { children: rightMessage })] })), _jsx(LinearProgress, { "aria-label": ariaLabelledBy ? undefined : ariaLabel, "aria-labelledby": ariaLabelledBy ?? (hasMessage && !ariaLabel ? messageId : undefined), id: id || progressBarId, palette: palette, height: height, variant: variant, value: value, color: color })] }));
});
ProgressBar.displayName = "ProgressBar";
ProgressBar.defaultProps = {
    palette: "expressiveInformative",
    stringMap: {},
    value: 0,
    color: ""
};
